import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../button/button';
import { Inline } from '../../inline/inline';

type PageControlsProps = {
  isPreviousPageDisabled: boolean;
  isNextPageDisabled: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
};

export const PageControls = ({
  isPreviousPageDisabled,
  isNextPageDisabled,
  onPreviousPage,
  onNextPage,
}: PageControlsProps) => {
  return (
    <Inline justify="between" className="rounded-full bg-seapoint-gray-background-modal p-2">
      <Button
        variant="ghost"
        size="none"
        disabled={isPreviousPageDisabled}
        className="rounded-none"
        onClick={onPreviousPage}
      >
        <Inline space={1}>
          <div className="h-4 w-4 overflow-clip">
            <ChevronLeft className="h-full w-full text-black" />
          </div>
        </Inline>
        <p className="text-xs font-medium text-black">Prev page</p>
      </Button>

      <div className="h-4 w-px bg-seapoint-gray-border"></div>

      <Button variant="ghost" size="none" disabled={isNextPageDisabled} className="rounded-none" onClick={onNextPage}>
        <Inline space={1}>
          <div className="h-4 w-4 overflow-clip">
            <ChevronRight className="h-full w-full text-black" />
          </div>

          <p className="text-xs font-medium text-black">Next page</p>
        </Inline>
      </Button>
    </Inline>
  );
};
